import { Body, Link } from '@cognite/cogs.js-v10';
import { UnleashKeys } from '@infield/constants/unleash-keys';
import { AppConfigUseFlagContext } from '@infield/features/app-config/app-config-use-flag.context';
import { useContext } from 'react';

type MigrationConfirmationContentProps = {
  inputValue: string;
};

export const MigrationConfirmationContent = ({
  inputValue,
}: MigrationConfirmationContentProps) => {
  const { useFlag } = useContext(AppConfigUseFlagContext);
  const { isEnabled: isConfigConfirmationEnabled } = useFlag(
    UnleashKeys.save_config_confirmation,
    {
      forceRerender: true,
      fallback: false,
    }
  );

  const actionText = isConfigConfirmationEnabled ? 'Save' : 'Confirm';

  return (
    <Body>
      Pressing &apos;{actionText}&apos; will cause all application data
      associated with this location to be stored in and fetched from the{' '}
      {inputValue} space. Make sure users in this location have access to the
      new space before proceeding.
      <br />
      <br />
      Any existing application data on this location must be migrated manually.
      CDF transformations for this can be found{' '}
      <Link
        target="_blank"
        href="https://github.com/cognitedata/apm_datamodels/tree/main/transformations/infield/migrate_app_data_to_new_space"
      >
        here
      </Link>
      .
    </Body>
  );
};
